import { Visibility, VisibilityOff } from "@mui/icons-material"
import { Typography, TextField, InputAdornment, IconButton, Button, Box, Link } from "@mui/material"
import { Dispatch, SetStateAction } from "react"
import { ILoginScreen } from "../Login"
import { ProfileType } from "../../../Types/General"

interface AccountTypeProps {
    setScreen: Dispatch<SetStateAction<ILoginScreen>>
    setLoginType: Dispatch<SetStateAction<ProfileType | undefined>>
}
export const AccountType = (props: AccountTypeProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handlClick = (type: ProfileType) =>{
        props.setLoginType(type)
        props.setScreen(ILoginScreen['login'])
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Typography variant="body-large" marginBottom={"30px"}>Which type of user are you?</Typography>
            <Box
                display={"flex"}
                flexDirection={"row"}
                gap={2}
            >
                <Button variant="contained" size="large" onClick={() => handlClick(ProfileType['Talent'])}>I'm a Talent</Button>
                <Button variant="contained" size="large" onClick={() => handlClick(ProfileType['Client'])}>I'm a Client</Button>
            </Box>
            <Typography variant="body-small" marginTop={"30px"}>Need an account? <Link href={`/signup`}>Sign up</Link></Typography>
        </>
    )
}